/**
 * Texts for Animations page
 * 
 * VIDEO URL FORMATS SUPPORTED:
 * 1. YouTube URLs:
 *    - https://www.youtube.com/watch?v=VIDEO_ID
 *    - https://youtu.be/VIDEO_ID
 *    - https://www.youtube.com/embed/VIDEO_ID
 * 
 * 2. Local video files:
 *    - /video/filename.mp4
 *    - Relative or absolute paths to MP4 files
 * 
 * Simply edit the 'videoUrl' field in each video object below.
 * The system automatically detects YouTube links and displays them accordingly.
 */
export const animationsPageText = {
    title: 'Animations - CamAPS FX',
    titleMeta: 'CamAPS FX Animations - Step-by-step visual guides',
    descriptionMeta: 'Watch short animations to help answer CamDiab\'s most common questions about using the CamAPS FX app.',
    keywords:
        'camaps fx animations, camaps tutorials, diabetes app tutorials, insulin pump animations, cgm tutorials, video guides',
    localeMeta: 'en_gb',

    mainHeader: 'Animations',
    mainSubHeader: 'These \'bite-sized\' short animations have been designed to answer a few of CamDiab\'s most common questions.',

    filterAll: 'All',
    filterYpsoPump: 'YpsoPump',
    filterDana: 'Dana',
    sortNewest: 'Newest',
    sortOldest: 'Oldest',
    sortAZ: 'A-Z',
    sortPopular: 'Most popular',

    // Getting Started Section
    gettingStartedHeader: 'Ready to get started?',
    step1Title: '<strong>Step 1:</strong> Download the app',
    step2Title: '<strong>Step 2:</strong> Create an account',
    step3Title: '<strong>Step 3:</strong> Begin the in-app essential training',
    step4Title: '<strong>Step 4:</strong> Pair with your chosen pump and CGM (with the approval of your healthcare team) or explore the app with <strong>Virtual Mode</strong>',
    virtualModeTooltipText: 'Virtual mode allows you to trial the app without being connected to a real insulin pump and CGM sensor.',
    
    // Support Section
    supportSectionTitle: 'Need help installing the app?',
    supportSectionText: 'Visit our support section for guidance.',
    supportButtonText: ' SUPPORT',

    // Additional Resources Section
    additionalResourcesTitle: 'Additional Resources',
    additionalResourcesSubtitle: 'Explore more ways to learn about CamAPS FX',
    
    userTrainingTitle: 'User Training',
    userTrainingDescription: 'Comprehensive training materials to help you get started with CamAPS FX.',
    userTrainingLink: '/user-training',
    
    webinarsTitle: 'Webinars',
    webinarsDescription: 'Join our live webinars and recorded sessions to learn more.',
    webinarsLink: '#',
    
    factsheetsTitle: 'Factsheets',
    factsheetsDescription: 'Download helpful factsheets and guides for quick reference.',
    factsheetsLink: '#',

    videos: [
        // {
        //     id: 1,
        //     title: 'Getting Started with YpsoPump',
        //     description: 'Learn how to set up your YpsoPump with CamAPS FX.',
        //     date: '15 Dec 2024',
        //     duration: '5:24',
        //     thumbnail: '/images/video-placeholder.svg',
        //     category: 'ypso',
        //     videoUrl: 'https://www.youtube.com/watch?v=9xwazD5SyVg', // Replace VIDEO_ID_1 with actual video ID from @camdiab channel
        //     views: 5420
        // },
        // {
        //     id: 2,
        //     title: 'Dana Pump Setup Guide',
        //     description: 'Step-by-step guide for Dana pump configuration.',
        //     date: '10 Dec 2024',
        //     duration: '7:15',
        //     thumbnail: '/images/video-placeholder.svg',
        //     category: 'dana',
        //     videoUrl: 'https://www.youtube.com/watch?v=9xwazD5SyVg', // Replace VIDEO_ID_2 with actual video ID from @camdiab channel
        //     views: 8950
        // },
        // {
        //     id: 3,
        //     title: 'Understanding Your CGM Data',
        //     description: 'Learn how to interpret your glucose readings.',
        //     date: '5 Dec 2024',
        //     duration: '4:33',
        //     thumbnail: '/images/video-placeholder.svg',
        //     category: 'all',
        //     videoUrl: 'https://www.youtube.com/watch?v=9xwazD5SyVg', // Replace VIDEO_ID_3 with actual video ID from @camdiab channel
        //     views: 12340
        // },
        // {
        //     id: 4,
        //     title: 'YpsoPump Advanced Features',
        //     description: 'Explore advanced settings and customization.',
        //     date: '1 Dec 2024',
        //     duration: '6:48',
        //     thumbnail: '/images/video-placeholder.svg',
        //     category: 'ypso',
        //     videoUrl: 'https://www.youtube.com/watch?v=9xwazD5SyVg', // Replace VIDEO_ID_4 with actual video ID from @camdiab channel
        //     views: 3210
        // },
        // {
        //     id: 5,
        //     title: 'Dana Pump Troubleshooting',
        //     description: 'Common issues and solutions for Dana pump.',
        //     date: '28 Nov 2024',
        //     duration: '5:12',
        //     thumbnail: '/images/video-placeholder.svg',
        //     category: 'dana',
        //     videoUrl: 'https://www.youtube.com/watch?v=9xwazD5SyVg', // Replace VIDEO_ID_5 with actual video ID from @camdiab channel
        //     views: 6780
        // },
        // {
        //     id: 6,
        //     title: 'Managing Meal Boluses',
        //     description: 'Best practices for meal-time insulin delivery.',
        //     date: '25 Nov 2024',
        //     duration: '8:05',
        //     thumbnail: '/images/video-placeholder.svg',
        //     category: 'all',
        //     videoUrl: 'https://www.youtube.com/watch?v=9xwazD5SyVg', // Replace VIDEO_ID_6 with actual video ID from @camdiab channel
        //     views: 9450
        // },
        // {
        //     id: 7,
        //     title: 'YpsoPump Battery Management',
        //     description: 'Tips for extending battery life and replacement.',
        //     date: '20 Nov 2024',
        //     duration: '3:27',
        //     thumbnail: '/images/video-placeholder.svg',
        //     category: 'ypso',
        //     videoUrl: 'https://www.youtube.com/watch?v=9xwazD5SyVg', // Replace VIDEO_ID_7 with actual video ID from @camdiab channel
        //     views: 4120
        // },
        // {
        //     id: 8,
        //     title: 'Dana Pump Cartridge Change',
        //     description: 'How to safely change your insulin cartridge.',
        //     date: '15 Nov 2024',
        //     duration: '4:55',
        //     thumbnail: '/images/video-placeholder.svg',
        //     category: 'dana',
        //     videoUrl: 'https://www.youtube.com/watch?v=9xwazD5SyVg', // Replace VIDEO_ID_8 with actual video ID from @camdiab channel
        //     views: 7230
        // },
        // {
        //     id: 9,
        //     title: 'Exercise Mode Setup',
        //     description: 'Configure settings for physical activity.',
        //     date: '10 Nov 2024',
        //     duration: '6:18',
        //     thumbnail: '/images/video-placeholder.svg',
        //     category: 'all',
        //     videoUrl: 'https://www.youtube.com/watch?v=9xwazD5SyVg', // Replace VIDEO_ID_9 with actual video ID from @camdiab channel
        //     views: 10560
        // },
        // {
        //     id: 10,
        //     title: 'YpsoPump Alerts & Notifications',
        //     description: 'Customize your pump alerts and alarms.',
        //     date: '5 Nov 2024',
        //     duration: '5:41',
        //     thumbnail: '/images/video-placeholder.svg',
        //     category: 'ypso',
        //     videoUrl: 'https://www.youtube.com/watch?v=9xwazD5SyVg', // Replace VIDEO_ID_10 with actual video ID from @camdiab channel
        //     views: 5890
        // },
        // {
        //     id: 11,
        //     title: 'Dana Pump Connectivity',
        //     description: 'Bluetooth pairing and connection tips.',
        //     date: '1 Nov 2024',
        //     duration: '7:52',
        //     thumbnail: '/images/video-placeholder.svg',
        //     category: 'dana',
        //     videoUrl: 'https://www.youtube.com/watch?v=9xwazD5SyVg', // Replace VIDEO_ID_11 with actual video ID from @camdiab channel
        //     views: 8120
        // },
        // {
        //     id: 12,
        //     title: 'Night Time Settings',
        //     description: 'Optimize your settings for better sleep.',
        //     date: "18 Apr 2016",
        //     duration: '6:03',
        //     thumbnail: '/images/video-placeholder.svg',
        //     category: 'all',
        //     videoUrl: 'https://www.youtube.com/watch?v=9xwazD5SyVg', // Replace VIDEO_ID_12 with actual video ID from @camdiab channel
        //     views: 11230
        // }
        {
            "id": 1,
            "title": "Virtual Mode",
            "description": "Virtual Mode",
            "date": "15 Dec 2025",
            "duration": "1:30",
            "category": "all",
            "videoUrl": "https://youtu.be/PUXDc5nXcaU",
            "views": 500
        },
        {
            "id": 2,
            "title": "Travelling with CamAPS FX",
            "description": "Travelling with CamAPS FX",
            "date": "12 Dec 2025",
            "duration": "2:49",
            "category": "ypso",
            "videoUrl": "https://youtu.be/unUO7daCp3c",
            "views": 31000
        },
        {
            "id": 3,
            "title": "Travelling with CamAPS FX",
            "description": "Travelling with CamAPS FX",
            "date": "12 Dec 2025",
            "duration": "2:50",
            "category": "dana",
            "videoUrl": "https://youtu.be/GplwuTfOGv8",
            "views": 30900
        },
        {
            "id": 4,
            "title": "Understanding Highs and Lows",
            "description": "Understanding Highs and Lows",
            "date": "12 Dec 2025",
            "duration": "4:55",
            "category": "dana",
            "videoUrl": "https://youtu.be/mR_wO0BM9mM",
            "views": 29900
        },
        {
            "id": 5,
            "title": "Understanding Highs and Lows (mmol/L)",
            "description": "Understanding Highs and Lows (mmol/L)",
            "date": "12 Dec 2025",
            "duration": "4:55",
            "category": "YpsoPump ",
            "videoUrl": "https://youtu.be/Y0dhj7hvXgM",
            "views": 30000
        },
        {
            "id": 6,
            "title": "Understanding Highs and Lows (mg/dL)",
            "description": "Understanding Highs and Lows (mg/dL)",
            "date": "12 Dec 2025",
            "duration": "4:55",
            "category": "YpsoPump ",
            "videoUrl": "https://youtu.be/rr6oytHLT74",
            "views": 29000
        },
        {
            "id": 7,
            "title": "CamAPS FX's MealAssist",
            "description": "CamAPS FX's MealAssist",
            "date": "3 Dec 2025",
            "duration": "1:36",
            "category": "all",
            "videoUrl": "https://youtu.be/On-YDive00w",
            "views": 400
        },
        {
            "id": 8,
            "title": "Using CamAPS FX when pregnant",
            "description": "Using CamAPS FX when pregnant",
            "date": "17 Feb 2026",
            "duration": "6:41",
            "category": "dana",
            "videoUrl": "https://youtu.be/DrGDN-0iwrA",
            "views": 32900
        },
        {
            "id": 9,
            "title": "Using CamAPS FX when pregnant (mg/dL)",
            "description": "Using CamAPS FX when pregnant (mg/dL)",
            "date": "17 Feb 2026",
            "duration": "6:47",
            "category": "ypso",
            "videoUrl": "https://youtu.be/AM4MBXNtsSQ",
            "views": 32000
        },
        {
            "id": 10,
            "title": "Using CamAPS FX when pregnant (mmol/L)",
            "description": "Using CamAPS FX when pregnant (mmol/L)",
            "date": "17 Feb 2026",
            "duration": "6:42",
            "category": "ypso",
            "videoUrl": "https://youtu.be/F0CwAzxgOps",
            "views": 33000
        },
        {
            "id": 11,
            "title": "Body weight",
            "description": "Body weight",
            "date": "17 Feb 2026",
            "duration": "1:10",
            "category": "dana",
            "videoUrl": "https://youtu.be/MPL14Y6f4QI",
            "views": 23900
        },
        {
            "id": 12,
            "title": "Body weight",
            "description": "Body weight",
            "date": "17 Feb 2026",
            "duration": "1:10",
            "category": "ypso",
            "videoUrl": "https://youtu.be/JIVtrzBmQ2w",
            "views": 24000
        },
        {
            "id": 13,
            "title": "Total Daily Dose (TDD)",
            "description": "Total Daily Dose (TDD)",
            "date": "17 Feb 2026",
            "duration": "1:13",
            "category": "dana",
            "videoUrl": "https://youtu.be/2cFsVmXuJSk",
            "views": 22900
        },
        {
            "id": 14,
            "title": "Total Daily Dose (TDD)",
            "description": "Total Daily Dose (TDD)",
            "date": "17 Feb 2026",
            "duration": "1:13",
            "category": "ypso",
            "videoUrl": "https://youtu.be/yxz0nnAhM5E",
            "views": 23000
        },
        {
            "id": 15,
            "title": "CamAPS Companion",
            "description": "CamAPS Companion",
            "date": "3 Sep 2026",
            "duration": "2:49",
            "category": "ypso",
            "videoUrl": "https://youtu.be/KGbeN_Aw6Bw",
            "views": 6000
        },
        {
            "id": 16,
            "title": "CamAPS Companion",
            "description": "CamAPS Companion",
            "date": "3 Sep 2026",
            "duration": "2:49",
            "category": "dana",
            "videoUrl": "https://youtu.be/W3CFQYHcmJo",
            "views": 5900
        },
        {
            "id": 17,
            "title": "Sharing diabetes data - iOS app",
            "description": "Sharing diabetes data - iOS app",
            "date": "11 Aug 2026",
            "duration": "2:13",
            "category": "ypso",
            "videoUrl": "https://youtu.be/MrpZg-oOHdw",
            "views": 7000
        },
        {
            "id": 18,
            "title": "Sharing diabetes data - Android app",
            "description": "Sharing diabetes data - Android app",
            "date": "11 Aug 2026",
            "duration": "2:48",
            "category": "ypso",
            "videoUrl": "https://youtu.be/-48aU7X7iTs",
            "views": 8000
        },
        {
            "id": 19,
            "title": "Sharing diabetes data",
            "description": "Sharing diabetes data",
            "date": "11 Aug 2026",
            "duration": "2:35",
            "category": "dana",
            "videoUrl": "https://youtu.be/g8RQDWyf7gU",
            "views": 7900
        },
        {
            "id": 20,
            "title": "What is a patency pulse? (mg/dL)",
            "description": "What is a patency pulse? (mg/dL)",
            "date": "3 Sep 2026",
            "duration": "2:57",
            "category": "ypso",
            "videoUrl": "https://youtu.be/FLTC-KdA5MI",
            "views": 300
        },
        {
            "id": 21,
            "title": "What is a patency pulse? (mmol/L)",
            "description": "What is a patency pulse? (mmol/L)",
            "date": "3 Sep 2026",
            "duration": "2:56",
            "category": "ypso",
            "videoUrl": "https://youtu.be/naB6zUUlwkc",
            "views": 200
        },
        {
            "id": 201,
            "title": "What is a patency pulse?",
            "description": "What is a patency pulse?",
            "date": "3 Sep 2026",
            "duration": "2:56",
            "category": "dana",
            "videoUrl": "https://youtu.be/BIbDTrNx8s0",
            "views": 200
        },
        {
            "id": 22,
            "title": "Using Ease-off",
            "description": "Using Ease-off",
            "date": "11 Aug 2026",
            "duration": "3:21",
            "category": "ypso",
            "videoUrl": "https://youtu.be/ec3I0eMbtN8",
            "views": 15000
        },
        {
            "id": 23,
            "title": "Using Ease-off",
            "description": "Using Ease-off",
            "date": "11 Aug 2026",
            "duration": "3:20",
            "category": "dana",
            "videoUrl": "https://youtu.be/s6jKDLdfsDg",
            "views": 14900
        },
        {
            "id": 24,
            "title": "Using Boost",
            "description": "Using Boost",
            "date": "11 Aug 2026",
            "duration": "2:01",
            "category": "ypso",
            "videoUrl": "https://youtu.be/c3SkU7tI4rM",
            "views": 14000
        },
        {
            "id": 25,
            "title": "Using Boost",
            "description": "Using Boost",
            "date": "11 Aug 2026",
            "duration": "2:01",
            "category": "dana",
            "videoUrl": "https://youtu.be/ITaLBOMjghE",
            "views": 13900
        },
        {
            "id": 26,
            "title": "Using Block",
            "description": "Using Block",
            "date": "11 Aug 2026",
            "duration": "1:15",
            "category": "ypso",
            "videoUrl": "https://youtu.be/AK0tcsZ7uRQ",
            "views": 5000
        },
        {
            "id": 27,
            "title": "Using Block",
            "description": "Using Block",
            "date": "11 Aug 2026",
            "duration": "1:15",
            "category": "dana",
            "videoUrl": "https://youtu.be/UkAghv_IgzU",
            "views": 4900
        },
        {
            "id": 28,
            "title": "Using Auto mode",
            "description": "Using Auto mode",
            "date": "11 Aug 2026",
            "duration": "2:45",
            "category": "ypso",
            "videoUrl": "https://youtu.be/2eEgIGqClMw",
            "views": 18000
        },
        {
            "id": 29,
            "title": "Using Auto mode",
            "description": "Using Auto mode",
            "date": "3 Sep 2026",
            "duration": "2:44",
            "category": "dana",
            "videoUrl": "https://youtu.be/bII2jt0mYxQ",
            "views": 17900
        },
        {
            "id": 30,
            "title": "Using Add meal",
            "description": "Using Add meal",
            "date": "11 Aug 2026",
            "duration": "3:48",
            "category": "ypso",
            "videoUrl": "https://youtu.be/Lewch4s4gCc",
            "views": 16000
        },
        {
            "id": 31,
            "title": "Using Add meal",
            "description": "Using Add meal",
            "date": "11 Aug 2026",
            "duration": "3:49",
            "category": "dana",
            "videoUrl": "https://youtu.be/oZt4an1pJNo",
            "views": 15900
        },
        {
            "id": 32,
            "title": "Top technical tips - iOS app",
            "description": "Top technical tips - iOS app",
            "date": "3 Sep 2026",
            "duration": "3:07",
            "category": "ypso",
            "videoUrl": "https://youtu.be/LjfYPC07Q0k",
            "views": 27000
        },
        {
            "id": 33,
            "title": "Top technical tips - Android app",
            "description": "Top technical tips - Android app",
            "date": "3 Sep 2026",
            "duration": "3:20",
            "category": "ypso",
            "videoUrl": "https://youtu.be/5u1MaFyMiz0",
            "views": 28000
        },
        {
            "id": 34,
            "title": "Top technical tips",
            "description": "Top technical tips",
            "date": "3 Sep 2026",
            "duration": "3:21",
            "category": "dana",
            "videoUrl": "https://youtu.be/XpuSs5C_l-0",
            "views": 27900
        },
        {
            "id": 35,
            "title": "Setting up the Personal Glucose Target (mmol/L)",
            "description": "Setting up the Personal Glucose Target (mmol/L)",
            "date": "11 Aug 2026",
            "duration": "2:18",
            "category": "ypso",
            "videoUrl": "https://youtu.be/N7--wjRfbwk",
            "views": 20000
        },
        {
            "id": 36,
            "title": "Setting up the Personal Glucose Target",
            "description": "Setting up the Personal Glucose Target",
            "date": "11 Aug 2026",
            "duration": "2:18",
            "category": "dana",
            "videoUrl": "https://youtu.be/BQDqupWSWSA",
            "views": 19900
        },
        {
            "id": 37,
            "title": "Setting up the Personal Glucose Target (mg/dL)",
            "description": "Setting up the Personal Glucose Target (mg/dL)",
            "date": "11 Aug 2026",
            "duration": "2:19",
            "category": "ypso",
            "videoUrl": "https://youtu.be/feg6MPG9PDo",
            "views": 19000
        },
        {
            "id": 38,
            "title": "Setting up the bolus calculator (mmol/L)",
            "description": "Setting up the bolus calculator (mmol/L)",
            "date": "11 Aug 2026",
            "duration": "3:49",
            "category": "ypso",
            "videoUrl": "https://youtu.be/Gf3mJhjwG6c",
            "views": 22000
        },
        {
            "id": 39,
            "title": "Setting up the bolus calculator (mg/dL)",
            "description": "Setting up the bolus calculator (mg/dL)",
            "date": "17 Feb 2026",
            "duration": "3:44",
            "category": "ypso",
            "videoUrl": "https://youtu.be/KfROo8PfoQc",
            "views": 21000
        },
        {
            "id": 40,
            "title": "Setting up the bolus calculator",
            "description": "Setting up the bolus calculator",
            "date": "17 Feb 2026",
            "duration": "2:34",
            "category": "dana",
            "videoUrl": "https://youtu.be/HhwVwm9nlPU",
            "views": 21900
        },
        {
            "id": 43,
            "title": "Setting Alerts (mg/dL)",
            "description": "Setting Alerts (mg/dL)",
            "date": "20 May 2025",
            "duration": "2:32",
            "category": "ypso",
            "videoUrl": "https://youtu.be/kenUGSwY8x4",
            "views": 11000
        },
        {
            "id": 44,
            "title": "Setting Alerts (mmol/L)",
            "description": "Setting Alerts (mmol/L)",
            "date": "11 Aug 2026",
            "duration": "2:32",
            "category": "ypso",
            "videoUrl": "https://youtu.be/AlquHy_xMUE",
            "views": 12000
        },
        {
            "id": 45,
            "title": "Setting alerts",
            "description": "Setting alerts",
            "date": "11 Aug 2026",
            "duration": "2:32",
            "category": "dana",
            "videoUrl": "https://youtu.be/aNgXOi-mowQ",
            "views": 8900
        },
        {
            "id": 46,
            "title": "Pairing pump and sensor",
            "description": "Pairing pump and sensor",
            "date": "17 Feb 2026",
            "duration": "1:36",
            "category": "ypso",
            "videoUrl": "https://youtu.be/u2qDc7I7ZXg",
            "views": 25000
        },
        {
            "id": 47,
            "title": "Pairing pump and sensor",
            "description": "Pairing pump and sensor",
            "date": "17 Feb 2026",
            "duration": "1:30",
            "category": "dana",
            "videoUrl": "https://youtu.be/FpJ9ys5w4jY",
            "views": 24900
        },
        {
            "id": 48,
            "title": "Navigating the app",
            "description": "Navigating the app",
            "date": "11 Aug 2026",
            "duration": "2:55",
            "category": "ypso",
            "videoUrl": "https://youtu.be/gCcZmyxNZHw",
            "views": 26000
        },
        {
            "id": 49,
            "title": "Navigating the app",
            "description": "Navigating the app",
            "date": "11 Aug 2026",
            "duration": "2:55",
            "category": "dana",
            "videoUrl": "https://youtu.be/BLqIjeBe2RQ",
            "views": 25900
        },
        {
            "id": 50,
            "title": "Giving a meal bolus",
            "description": "Giving a meal bolus",
            "date": "11 Aug 2026",
            "duration": "1:01",
            "category": "ypso",
            "videoUrl": "https://youtu.be/RVxdqCmhlfI",
            "views": 17000
        },
        {
            "id": 51,
            "title": "Giving a meal bolus",
            "description": "Giving a meal bolus",
            "date": "11 Aug 2026",
            "duration": "1:00",
            "category": "dana",
            "videoUrl": "https://youtu.be/DYZSkWynlTY",
            "views": 16900
        },
        {
            "id": 52,
            "title": "Giving a manual correction",
            "description": "Giving a manual correction",
            "date": "11 Aug 2026",
            "duration": "1:45",
            "category": "ypso",
            "videoUrl": "https://youtu.be/S--bwTb-jII",
            "views": 13000
        },
        {
            "id": 53,
            "title": "Giving a manual correction",
            "description": "Giving a manual correction",
            "date": "11 Aug 2026",
            "duration": "1:45",
            "category": "dana",
            "videoUrl": "https://youtu.be/HNYN8kIdsPI",
            "views": 12900
        },
        {
            "id": 54,
            "title": "Changing carbohydrate units",
            "description": "Changing carbohydrate units",
            "date": "3 Sep 2026",
            "duration": "0:51",
            "category": "ypso",
            "videoUrl": "https://youtu.be/exoJnTzidLI",
            "views": 2000
        },
        {
            "id": 55,
            "title": "Changing carbohydrate units",
            "description": "Changing carbohydrate units",
            "date": "3 Sep 2026",
            "duration": "0:51",
            "category": "dana",
            "videoUrl": "https://youtu.be/A_P7riQOPsc",
            "views": 1900
        },
        {
            "id": 56,
            "title": "Calibrating the sensor (mmol/L)",
            "description": "Calibrating the sensor (mmol/L)",
            "date": "3 Sep 2026",
            "duration": "2:23",
            "category": "ypso",
            "videoUrl": "https://youtu.be/8RIpmynSWok",
            "views": 3000
        },
        {
            "id": 205,
            "title": "Calibrating the sensor (mg/dL)",
            "description": "Calibrating the sensor (mg/dL)",
            "date": "3 Sep 2026",
            "duration": "2:23",
            "category": "ypso",
            "videoUrl": "https://youtu.be/_9vMLX3bTJo",
            "views": 3000
        },
        {
            "id": 57,
            "title": "Calibrating the sensor",
            "description": "Calibrating the sensor",
            "date": "3 Sep 2026",
            "duration": "2:08",
            "category": "dana",
            "videoUrl": "https://youtu.be/milroC9eF-E",
            "views": 2900
        },
        {
            "id": 58,
            "title": "Adjusting preset meal sizes",
            "description": "Adjusting preset meal sizes",
            "date": "11 Aug 2026",
            "duration": "0:37",
            "category": "ypso",
            "videoUrl": "https://youtu.be/rUm9Y-m07Aw",
            "views": 4000
        },
        {
            "id": 59,
            "title": "Adjusting preset meal sizes",
            "description": "Adjusting preset meal sizes",
            "date": "11 Aug 2026",
            "duration": "0:37",
            "category": "dana",
            "videoUrl": "https://youtu.be/t-xGygiAvbA",
            "views": 3900
        },
        {
            "id": 60,
            "title": "Managing physical activity",
            "description": "Managing physical activity",
            "date": "3 Sep 2026",
            "duration": "6:16",
            "category": "ypso",
            "videoUrl": "https://youtu.be/Tnf1frKSNFI",
            "views": 34000
        },
        {
            "id": 61,
            "title": "Managing physical activity",
            "description": "Managing physical activity",
            "date": "3 Sep 2026",
            "duration": "6:16",
            "category": "dana",
            "videoUrl": "https://youtu.be/m4vwQuem-_8",
            "views": 33900
        },
        {
            "id": 62,
            "title": "How does CamAPS FX drive insulin delivery?",
            "description": "How does CamAPS FX drive insulin delivery?",
            "date": "11 Aug 2026",
            "duration": "3:30",
            "category": "ypso",
            "videoUrl": "https://youtu.be/NazbZLST-u8",
            "views": 35000
        },
        {
            "id": 63,
            "title": "How does CamAPS FX drive insulin delivery?",
            "description": "How does CamAPS FX drive insulin delivery?",
            "date": "11 Aug 2026",
            "duration": "3:28",
            "category": "dana",
            "videoUrl": "https://youtu.be/4ZSrJ-jwLoE",
            "views": 34900
        },
        {
            "id": 64,
            "title": "How does CamAPS FX learn?",
            "description": "How does CamAPS FX learn?",
            "date": "11 Aug 2026",
            "duration": "4:23",
            "category": "ypso",
            "videoUrl": "https://youtu.be/BGevr-RJjoc",
            "views": 36000
        },
        {
            "id": 65,
            "title": "How does CamAPS FX learn?",
            "description": "How does CamAPS FX learn?",
            "date": "11 Aug 2026",
            "duration": "4:23",
            "category": "dana",
            "videoUrl": "https://youtu.be/9U0W6kin1Z4",
            "views": 35900
        },
        {
            "id": 66,
            "title": "CamAPS Liberty",
            "description": "CamAPS Liberty",
            "date": "8 Oct 2026",
            "duration": "3:16",
            "category": "ypso",
            "videoUrl": "https://youtu.be/W-7cq3CQ7pg",
            "views": 0
        },
        {
            "id": 67,
            "title": "CamAPS Liberty",
            "description": "CamAPS Liberty",
            "date": "8 Oct 2026",
            "duration": "3:16",
            "category": "dana",
            "videoUrl": "https://youtu.be/W-7cq3CQ7pg",
            "views": 0
        },
        {
            "id": 68,
            "title": "Practical Tips: CamAPS Liberty",
            "description": "Practical Tips: CamAPS Liberty",
            "date": "2 Nov 2026",
            "duration": "1:49",
            "category": "ypso",
            "videoUrl": "https://youtu.be/QAYy8dTXUUc",
            "views": 0
        },
        {
            "id": 69,
            "title": "Practical Tips: CamAPS Liberty",
            "description": "Practical Tips: CamAPS Liberty",
            "date": "2 Nov 2026",
            "duration": "1:49",
            "category": "dana",
            "videoUrl": "https://youtu.be/QAYy8dTXUUc",
            "views": 0
        }

    ]
};

